export default "/images/cdccf27cfb3a479aeb27124e631b358e.avif";